module.exports = __webpack_public_path__ + "img/68.96929600.jpg";